import { Typography } from '@repo/ui';
import { TextLink } from 'components';

import styles from './ActionPlanDisclaimer.module.css';

const ActionPlanDisclaimer = () => {
  return (
    <div className={styles.container}>
      <Typography variant='body-s' serif>
        Every product in your Action Plan is there for a reason: it supports
        something specific in your results.&nbsp;
        <TextLink
          to={
            'https://www.tinyhealth.com/blog/why-we-removed-affiliate-commissions-from-recommendations'
          }
          label='We don’t earn commission from these links'
          target='_blank'
          rel='noopener noreferrer'
        />
        —each recommendation is science-backed, carefully vetted, and
        personalized for your microbiome health.
      </Typography>
      <Typography variant='body-s' serif>
        While grounded in research, our recommendations aren’t a substitute for
        medical advice. Check with your practitioner before making changes to
        your diet, switching up your routine, or adding supplements.
      </Typography>
    </div>
  );
};

export default ActionPlanDisclaimer;
